<template>
    <div class="customlistSide">
        <div class="customlistSideHeader">
            <div class="customerListText" @click="customerClick" :class="{customerActive:this.$route.name==='/customerInfo'}" ><span>客户线索</span></div>
            <div class="CompanyListText" @click="companyClick" :class="{customerActive:this.$route.name==='/leadsQunInfo'}" v-if="isHasLeadQun"><span>群线索</span></div>
        </div>
        <div class="customlistSideRouter">
                <router-view name="sideRouter"
                             :clientTotals="clientTotal"
                             :clientCompanyTotal="clientCompanyTotal"
                             :clientListNew="clientListNew"
                             :companyList="companyList"
                             :clientSeach="clientSeach"
                             :filterId="filterId"
                             :companySearchNum="companySearchNum"
                             @modifyClientFilter="modifyClientFilter"
                             @editFilter="editFilter"
                             ref="sideRouter"

                />
        </div>
    </div>
</template>

<script>
    export default {
        name: "CustomerListSide",
        data(){
         return{
             isActive:1,
             customerIsCheck:false,
            isHasLeadQun:false
         }
        },
        props:{
            clientTotal:Number,
            clientCompanyTotal:Number,
            clientListNew:{
                type:Array,
                default(){
                    return []
                }
            },
            companyList:{
                type:Array,
                default(){
                    return []
                }
            },
            clientSeach:{
                type:Array,
                default(){
                    return []
                }
            },
            filterId:String,
            companySearchNum:Number

        },
        mounted() {
            this.customerIsCheck=true
            let privilege =  localStorage.getItem('appoint_scrm_all_clue_privilege');
            console.debug('privilege',privilege)
            if (privilege){
              this.isHasLeadQun = true
            }
            else {
              this.isHasLeadQun = false
            }
        },
        methods:{
            customerClick(){

                this.$router.push({
                    path:'/customerInfo',
                    name:'/customerInfo'
                })
                this.isActive=1
                this.company=0
            },
            companyClick(){

                this.$router.push({
                    path:'/leadsQunInfo',
                    name:'/leadsQunInfo'
                })
                this.isActive=2
                this.company=1
            },
            modifyClientFilter(){
                this.$emit('modifyClientFilter')
            },
            editFilter(){
                this.$emit('editFilter')
            }
        }
    }
</script>

<style scoped lang="less">
    .customlistSide{
        width: 200px;
        background-color: #FFFFFF;
    }
    .customlistSidetTitle{
        height: 56px;
        line-height: 56px;
        text-align: center;
        font-size: 18px;
        //font-weight: 600;
        color: #303133;
        border-bottom: 1px solid #dddddd;
    }
    .customlistSideHeader{
        display: flex;
        border-bottom: 1px solid #dddddd;
        // border-right: 1px solid #dddddd;
    }
    .customerListText,.CompanyListText{
        flex: 1;
        font-size: 14px;
        text-align: center;
        height: 40px;
        line-height: 40px;
        cursor: pointer;
        padding: 8px 0px;
    }
    .customerActive{
        color: white;
    }

</style>